import { render, staticRenderFns } from "./advertisers-table.vue?vue&type=template&id=9cd3123c&"
import script from "./advertisers-table.vue?vue&type=script&lang=ts&"
export * from "./advertisers-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports